import React, { useState } from 'react';
import { X, Loader2 } from 'lucide-react';

const ProductModal = ({ service, isOpen, onClose, onSubmit }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await onSubmit({
        serviceId: service.id,
        serviceName: service.name,
        price: service.priceRange.split(' - ')[0].replace(/[^\d.]/g, ''), // Get the minimum price
        email: email
      });

      if (response?.confirmationUrl) {
        window.location.href = response.confirmationUrl;
      }
    } catch (err) {
      setError(err.message || 'Произошла ошибка при создании платежа');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg max-w-md w-full mx-4 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Modal content */}
        <div className="p-6">
          <div className={`p-3 rounded-xl bg-gradient-to-r ${service.color} w-fit mb-4`}>
            <div className="text-white">
              {service.icon}
            </div>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            {service.name}
          </h3>

          <p className="text-gray-600 mb-4">
            {service.description}
          </p>

          <div className="mb-6">
            <h4 className="font-semibold text-gray-900 mb-2">Включает:</h4>
            <ul className="space-y-2">
              {service.includes.map((item, index) => (
                <li key={index} className="flex items-center text-sm text-gray-600">
                  <span className="w-1.5 h-1.5 rounded-full bg-blue-500 mr-2" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="mb-6">
            <span className="text-lg font-bold text-gray-900">
              Стоимость: {service.priceRange}
            </span>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email для связи
              </label>
              <input
                type="email"
                id="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="your@email.com"
              />
            </div>

            {error && (
              <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className={`w-full px-4 py-3 rounded-lg text-white bg-gradient-to-r ${service.color} transform transition-all duration-300 hover:scale-105 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center`}
            >
              {isLoading ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : (
                'Оформить заказ'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;